import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { ExceptionData } from '../../../types'

export const createExceptions = async (payload: ExceptionData) => {
  const body = payload
  const response = await axios.post(`${getAPIService}/v2/api/cron-tasks/context_exceptions`, body)
  return response.data
}
